import { render, staticRenderFns } from "./CerrahiUygTanimlama.vue?vue&type=template&id=52e938bc&scoped=true&"
import script from "./CerrahiUygTanimlama.vue?vue&type=script&lang=js&"
export * from "./CerrahiUygTanimlama.vue?vue&type=script&lang=js&"
import style0 from "./CerrahiUygTanimlama.vue?vue&type=style&index=0&id=52e938bc&scoped=true&lang=css&"
import style1 from "./CerrahiUygTanimlama.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e938bc",
  null
  
)

export default component.exports